module.exports = "pegasus/assets/blocks/column-13-basic.png";